import React from "react";

export interface MessageState {
    type: "danger" | "success" | "warning";
    message: string;
}

export function MessageDisplay(props: {message?: MessageState}): JSX.Element {
    if(!props.message) return <></>;
    return <div className={"fw-normal p-2 alert alert-"+props.message.type} dangerouslySetInnerHTML={{__html: props.message.message}} />;
}